import { Service } from '@/tools'
export class contractExcelService<T extends TContract.Excel> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TContract.Excel}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  //上传
  private postUpload<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TContract.Excel}`, data?: TCommon.Json, toast?: string) {
    return this.post(
      {
        url: url,
        headers: {
          'Content-type': 'multipart/form-data',
        },
        method: 'post',
        data: data,
      },
      data,
      toast
    )
  }
  //联营商品清单导出
  exportCommodityList = <K extends T['ApiExportCommodityList']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiExportCommodityList', data, 'blob')
  // 合同导出
  exportContract = <K extends T['ApiExportContract']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiExportContract', data, 'blob')
  //补充协议导出
  exportSuppAgreement = <K extends T['ApiExportSuppAgreement']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiExportSuppAgreement', data, 'blob')
  //其他合同导出
  exportOtherContract = <K extends T['ApiExportOtherContract']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiExportOtherContract', data, 'blob')
  //采购价格关联联商品导入
  importPurchasePriceCommodity = <K extends T['ApiImportPurchasePriceCommodity']>(data: K['req']): Promise<K['res']> =>
    this.postUpload('v1/ApiImportPurchasePriceCommodity', data)
  //采购折扣关联商品导入
  importPurchaseDiscoutCommodity = <K extends T['ApiImportPurchaseDiscoutCommodity']>(data: K['req']): Promise<K['res']> =>
    this.postUpload('v1/ApiImportPurchaseDiscoutCommodity', data)
  //销售折扣关联商品导入
  importSalesDiscoutCommodity = <K extends T['ApiImportSalesDiscoutCommodity']>(data: K['req']): Promise<K['res']> =>
    this.postUpload('v1/ApiImportSalesDiscoutCommodity', data)
  //销售折扣关联商品导入（顺加）
  importCommodityMarkupDiscount = <K extends T['ApiImportSalesDiscoutCommodity']>(data: K['req']): Promise<K['res']> =>
    this.postUpload('v1/ApiImportCommodityMarkupDiscount', data)
  //销售价格关联联商品导入
  importSalesPriceCommodity = <K extends T['ApiImportSalesPriceCommodity']>(data: K['req']): Promise<K['res']> =>
    this.postUpload('v1/ApiImportSalesPriceCommodity', data)
  //联营商品清单关联联商品导入
  importUnitizationListCommodity = <K extends T['ApiImportUnitizationListCommodity']>(data: K['req']): Promise<K['res']> =>
    this.postUpload('v1/ApiImportUnitizationListCommodity', data)
  //联营价格关联联商品导入
  importUnitizationPriceCommodity = <K extends T['ApiImportUnitizationPriceCommodity']>(data: K['req']): Promise<K['res']> =>
    this.postUpload('v1/ApiImportUnitizationPriceCommodity', data)
  //合作出版折扣关联联商品导入
  importPublishDiscountCommodity = <K extends T['ApiImportUnitizationPriceCommodity']>(data: K['req']): Promise<K['res']> =>
    this.postUpload('v1/ApiImportUnitizationPriceCommodity', data)
  //服务价格关联联商品导入
  importServePriceCommodity = <K extends T['ApiImportServePriceCommodity']>(data: K['req']): Promise<K['res']> =>
    this.postUpload('v1/ApiImportServePriceCommodity', data)
  //价格导入
  importCommodityPrice = <K extends T['ApiImportCommodityPrice']>(data: K['req']): Promise<K['res']> =>
    this.postUpload('v1/ApiImportCommodityPrice', data)
  //sku导入
  importCommoditySku = <K extends T['ApiImportCommoditySku']>(data: K['req']): Promise<K['res']> => this.postUpload('v1/ApiImportCommoditySku', data)
  //折扣导入
  importCommodityDiscount = <K extends T['ApiImportCommodityDiscount']>(data: K['req']): Promise<K['res']> =>
    this.postUpload('v1/ApiImportCommodityDiscount', data)
  // 导入商品-折扣（不带最小值））
  importCommodityDiscountNoMin = <K extends T['ApiImportCommodityDiscount']>(data: K['req']): Promise<K['res']> =>
    this.postUpload('v1/ApiImportCommodityDiscountNoMin', data)
  //（导入商品-折扣（甲方供货折扣））
  importCommodityFirstPartySupplyDiscount = <K extends T['ApiImportCommodityDiscount']>(data: K['req']): Promise<K['res']> =>
    this.postUpload('v1/ApiImportCommodityFirstPartySupplyDiscount', data)

  //  税率管理导入 /api/contract/excel/v1/importTaxRate
  importTaxRate = <K extends T['ApiImportTaxRate']>(data: K['req']): Promise<K['res']> => this.postUpload('v1/ApiImportTaxRate', data)
}
